/**
 * Когда показывать телефонную оболочку.
 *
 * Признак не один, потому что случаев два: приложение на Android и обычный
 * браузер телефона, куда техник зашёл по адресу. Ширина сама по себе не годится
 * — узкое окно на компьютере не должно превращать программу в телефонную.
 */

const KEY = 'ui-mode'

/** Похоже ли устройство на телефон — без учёта ручного переключения. */
export function isPhone(): boolean {
  if (typeof navigator === 'undefined') return false

  const ua = navigator.userAgent
  const phoneOS = /Android|iPhone|iPod/i.test(ua)
  const touch = navigator.maxTouchPoints > 0
  const narrow = window.innerWidth < 700

  return phoneOS || (touch && narrow)
}

export function isMobileUI(): boolean {
  // Ручное переключение: удобно проверять оболочку на компьютере, и выручает,
  // если определение ошиблось на незнакомом устройстве.
  try {
    const forced = localStorage.getItem(KEY)
    if (forced === 'mobile') return true
    if (forced === 'desktop') return false
  } catch {
    // приватный режим — просто определяем сами
  }

  return isPhone()
}

export function setUIMode(mode: 'mobile' | 'desktop' | 'auto'): void {
  try {
    if (mode === 'auto') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, mode)
  } catch {
    // ничего не поделать — останется автоопределение
  }
}
